module.exports = __webpack_public_path__ + "static/topography_left-2c0b4a038e3cf0f87ac73fe62ed78788.png";